import { TEACHER_PAYMENT_ALL_ACTIONS_TYPE } from "../actions-type";

const initialState = {
  teachersPayments: [],
  totalLength: 0,
  hasMore: true,
  loading: false,
  teachersSalaries: [],
};

export const teacherPaymentPaginationReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case TEACHER_PAYMENT_ALL_ACTIONS_TYPE.GET_TEACHER_PAYMENT_PAGINATION:
      return {
        ...state,
        teachersPayments: [
          ...state.teachersPayments,
          ...action.payload.teachers,
        ],
        totalLength: action.payload.totalLength,
        hasMore: !(action.payload.teachers.length < 20),
      };

    case TEACHER_PAYMENT_ALL_ACTIONS_TYPE.GET_TEACHERS_SALARIES:
      return {
        ...state,
        teachersSalaries: action.payload,
      };
    case TEACHER_PAYMENT_ALL_ACTIONS_TYPE.UPDATE_TEACHER_PAYMENT:
      return {
        ...state,
        teachersPayments: state.teachersPayments.map((teacher) =>
          teacher._id === action.payload._id ? action.payload : teacher
        ),
      };
    case TEACHER_PAYMENT_ALL_ACTIONS_TYPE.RESET_TEACHER_PAYMENT_PAGINATION:
      return {
        ...state,
        teachersPayments: [],
        teachersSalaries: [],
        totalLength: 0,
        hasMore: true,
      };
    case TEACHER_PAYMENT_ALL_ACTIONS_TYPE.TEACHER_PAYMENT_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};
